import { ScreenProvider } from "library/ScreenContext"
import StyledManager from "library/StyledManager"
import { ModalProvider } from "./ModalContext"

interface ProvidersProps {
	children: React.ReactNode
}

/**
 * providers here will be mounted once, and will never unmount
 */
export function RootProviders({ children }: ProvidersProps) {
	return (
		<ScreenProvider>
			<ModalProvider>{children}</ModalProvider>
		</ScreenProvider>
	)
}

/**
 * providers here will be unmounted and remounted on every route change
 */
export function RouteProviders({ children }: ProvidersProps) {
	return <StyledManager>{children}</StyledManager>
}
